// extracted by mini-css-extract-plugin
export default {"SearchList":"SearchList_SearchList__Xtua-","head":"SearchList_head__bSchQ","name":"SearchList_name__Io8Dp","date":"SearchList_date__175wx","content":"SearchList_content__qr4xo"};